import { ADMIN_ONLY_SETTING, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { getPrimaryTextClass } from 'helpers/sf_utils';
import useFeatureFlags from 'hooks/useFeatureFlags';
import React from 'react'
import { UncontrolledTooltip } from 'reactstrap';

const AdminOnlyIcon = ({ idFor, columnTitle = "", tooltipText = ADMIN_ONLY_SETTING, sortElement, filterElement }) => {
    const [isFeatureFlagActive] = useFeatureFlags();
    return (
        <>
            {columnTitle?.length > 0 && <span className="me-1">{columnTitle}{sortElement}{filterElement}</span> }
            {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS?.SF_FEATURE_FLAG_SHOW_ADMIN_ONLY_ICON) && (
                <>
                    <i
                        className={`bx bx-cog quote-funnel-setting-icon ms-1 ${getPrimaryTextClass()} ${isFeatureFlagActive(REQUIRED_FEATURE_FLAGS?.SF_FEATURE_FLAG_SHOW_NEW_TAB_DESIGN) && 'admin-icon'}`}
                        id={`admin-only-setting-${idFor}`}
                    ></i>
                    <UncontrolledTooltip placement="right" target={`admin-only-setting-${idFor}`}>
                        {tooltipText}
                    </UncontrolledTooltip>
                </>
            )}
        </>
    );
};

export default AdminOnlyIcon;